import { ReactNode, useEffect, useState } from 'react';
import { Sidebar } from '../Sidebar/Sidebar';
import { BlankLayout } from './BlankLayout';
import { MainLayoutContainer, MainLayoutContent } from './styles';
import { MobileHeader } from '../Sidebar/ui/MobileHeader/MobileHeader';
import { useResponsiveDevice } from '@/hooks/useResponsiveDevice';
import { useLockedScroll } from '@/hooks/useLockedScroll';
import { useCookiesPreferences } from '../CookiesBanner/cookiesContext';
import { useSupportWidget } from '@/hooks/useSupportWidget';

type MainLayoutType = {
  children?: ReactNode;
};

export const MainLayout = ({ children }: MainLayoutType) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { isDesktop } = useResponsiveDevice();
  const [, setLocked] = useLockedScroll();
  const { hasFunctionalCookiesConsent } = useCookiesPreferences();
  const { init, destroy } = useSupportWidget();

  useEffect(() => {
    setLocked(!!sidebarOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sidebarOpen]);

  useEffect(() => {
    if (hasFunctionalCookiesConsent) {
      init();
    } else {
      destroy();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasFunctionalCookiesConsent]);

  const toggleSidebar = () => {
    setSidebarOpen((opened) => !opened);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const sidebarNavigate = () => {
    if (isDesktop) return;

    closeSidebar();
  };

  return (
    <BlankLayout isLoading={false}>
      <MainLayoutContainer>
        <MobileHeader isOpen={sidebarOpen} onSidebarToggle={toggleSidebar} />
        <Sidebar isOpen={sidebarOpen} onNavigate={sidebarNavigate} onClose={closeSidebar} />
        <MainLayoutContent id='main'>{children}</MainLayoutContent>
      </MainLayoutContainer>
    </BlankLayout>
  );
};
